import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';

const useStyles = makeStyles((theme) => ({
	ol: {
		fontSize: '12px',
		paddingLeft: '20px',
		'& ol': {
			paddingInlineStart: '20px',
		},
		'& .lower-alpha': {
			listStyleType: 'lower-alpha',
		},
		'& .lower-roman': {
			listStyleType: 'lower-roman',
		},
		'& li': {
			marginBottom: '6px',
		},
	},
	p: {
		fontSize: '14px',
	},
}));

const Terms = () => {
	const classes = useStyles();

	return (
		<section
			style={{
				minHeight: 'inherit',
				color: 'white',
				margin: '0 auto',
				padding: '20px',
				maxWidth: '1024px',
				backgroundColor: '#f05b83',
			}}
		>
			<h1 style={{ textAlign: 'center' }}>TERMS OF USE</h1>
			<main>
				<p className={classes.p}>
					This Agreement is between You and Barun Kumar Ghadia. Please read these terms of use carefully by
					accessing or using this internet based platform, you agree to be bound by the terms described herein and all
					terms incorporated by reference. If you do not agree at all or any of these terms, do not use this
					internet-based platform.
				</p>
				<p className={classes.p}>
					Barun Kumar Ghadia <b>("Proprietor")</b> is the owner of vendingbuddy.shop,
					go.vendingbuddy.shop, VendingBuddy Store (collectively referred to as <b>"Vending Buddy"</b>) from Barun Kumar Ghadia
					("Vending Buddy"). These Terms of Use govern you, the User of Vending Buddy, and your conduct, regardless of the means of
					access. You represent and warrant you possess the capacity and legal right to enter into this Agreement and to
					use this Website in accordance with the terms and conditions herein. You also acknowledge and agree that,
					unless we specifically provide otherwise, this Agreement only applies to this site and our online activities
					and does not apply to any of our offline activities.
				</p>
				<p className={classes.p}>
					By using the services available on Vending Buddy <b>("Services")</b>, you consent to these terms, Vending Buddy’s Privacy
					Policy, and any supplemental terms provided to you for the Services (collectively, <b>"Terms"</b>) and Vending Buddy’s
					efforts to improve every User’s experience. Please read the Terms carefully, as they form the entire agreement
					between you and Vending Buddy. Do not continue to use Vending Buddy if you do not agree to take all of the terms and conditions
					stated on this page.
				</p>
				<ol className={classes.ol}>
					<li>
						Usage of Service -
						<ol className='lower-alpha'>
							<li>
								Logging into Vending Buddy: You shall be required to log onto Vending Buddy using your mobile number. Login shall be
								completed upon entering the one time password (“OTP”) sent to your mobile device. Please make sure that
								you enter the correct OTP.
							</li>
							<li>
								Upon logging in, You shall have the option of choosing products that you wish to purchase and move on to
								the payment page.
							</li>
						</ol>
					</li>
					<li>
						Authority
						<div>
							You agree that you are permitted to use the Services under applicable law. If you are accessing an
							account(s) on behalf of the account owner (e.g., as an administrator, consultant, analyst, etc.), the
							Terms apply to your activities on behalf of the account owner.
						</div>
					</li>
					<li>
						Age
						<ol className='lower-alpha'>
							<li>
								Vending Buddy does not include any age inappropriate content. User data is processed by the Proprietor, through
								verification and other internal checks, in a manner that both protects any user information as well as
								advances the best interests of children.
							</li>
							<li>
								Parents/adult guardians are required to monitor/regulate the products being viewed or activities
								undertaken by their wards who have not attained the Minimum Age. Parental control tools available from
								third party vendors/service providers might be useful in this regard. It shall also be responsibility of
								parents/adult guardians to ensure that their wards do not view products that is not appropriate for
								them.
							</li>
						</ol>
					</li>
					<li>
						Member Conduct. You agree not to use the Services to -
						<ol className='lower-roman'>
							<li>
								obtain or attempt to obtain unauthorized access to the Services or to the Proprietor’s servers, systems,
								network, or data;
							</li>
							<li>violate any applicable laws or regulations;</li>
							<li>
								impersonate any person or entity; or forge or manipulate headers or identifiers to disguise the origin
								of any products sold through the Service;
							</li>
							<li>
								tamper with mobile application to add advertisements or other commercial solicitations without our prior
								written permission;
							</li>
							<li>
								make available viruses or any other computer code, files, programs or Content designed to interrupt,
								destroy or limit the functionality of the Services or affect other users; or
							</li>
							<li>
								interfere with or disrupt the Service or servers, systems or networks connected to the Service in any
								way.
							</li>
						</ol>
					</li>
					<li>
						Use of Services -
						<ol className='lower-alpha'>
							<li>
								You must follow any guidelines or policies associated with the use of the Service. You must not misuse
								or interfere with the Service or try to access them using a method other than the interface and the
								instructions that we provide.
							</li>
							<li>
								You may use the Service only as permitted by law. Unless otherwise expressly stated, you may not access
								or reuse the Service, or any portion thereof, for any commercial purpose.
							</li>
							<li>
								Without our express written consent, you may not (a) use any automated means to access Vending Buddy or collect
								any information from the mobile application or website(including without limitation robots, spiders or
								scripts), or (b) frame the mobile application or website (or any part thereof), place pop-up windows
								over the mobile application or website (or any part thereof) pages, or otherwise affect the display of
								part or area of the mobile application or website.
							</li>
						</ol>
					</li>
					<li>
						Products -
						<ol className='lower-alpha'>
							<li>
								You as a responsible user must ensure to check the conditions of the Products purchased. You agree to
								check the expiry/ other product conditions of the items you purchase from any of our machines, stores,
								website and other avenues before consuming the same. You are entitled to report the same through our
								dedicated customer care channels in case you wish to do the same.
							</li>
							<li>
								The Proprietor holds no responsibility for any aftereffects of consumption of the goods sold. Users are
								encouraged to read the package information / check the expiry before consumption.
							</li>
						</ol>
					</li>
					<li>
						Refund Policy -
						<ol className='lower-alpha'>
							<li>
								Any item that is not vended/ not picked by the User before the closure of the door, will not be billed.
								Any money that has been paid by the User for the same, can either be refunded by the User or can be used
								for future transactions by the User. The current pending amount, refunds can be seen under wallet
								section.
							</li>
							<li>
								We take at most care in maintaining the fresh stock and prevent any damaged/ expired product reaching
								the kiosks. In case of purchasing an item(s) that was either expired/ damaged before the purchase time
								will be eligible for refund. This can be claimed by reaching out to our customer service team - through
								the mobile application.
							</li>
						</ol>
					</li>
					<li>
						Anti-Corruption Laws - You agree to comply with all applicable anti-corruption laws including laws that
						prohibit unlawful payments to anyone for a corrupt purpose in relation to these Terms.
					</li>
					<li>
						Support - Unless otherwise expressly stated, the Proprietor does not promise to provide you with any support
						for the Services. If the Proprietor does provide you with support, it is at our sole discretion and does not
						mean that we will continue to provide you with support in the future.
					</li>
					<li>
						Account Notices
						<ol className='lower-alpha'>
							<li>
								Login Information: You shall need to login to use the Service. You must ensure that the mobile number
								collected during login remains current, complete, accurate and truthful. In order to login, we may
								collect and keep possession of personal information such as your mobile number. By providing us with the
								same, you acknowledge and accept that we have your consent for the collection and processing of such
								provided information. Our possession and use of such information shall be in accordance with our Privacy
								Policy and Terms.
							</li>
							<li>
								Notices. We may provide you with notices, including service announcements and notices regarding changes
								to these Terms, by, but not limited to, email, regular mail, text message or SMS, MMS, push notification
								or in-app message, postings on the Services, telephone, or other reasonable means now known or hereafter
								developed. You consent to receive these notices by any and all of the foregoing means. You may not
								receive notices if you violate the Terms by accessing the Services in an unauthorized manner, and you
								will be deemed to have received any and all notices that would have been delivered had you accessed the
								Services in an authorized manner.
							</li>
						</ol>
					</li>
					<li>
						Modifying and Terminating Service; Amendment of Terms of Use -
						<ol className='lower-alpha'>
							<li>
								We are constantly innovating, changing and improving the Service. We may, without notice, add or remove
								functionalities or features or create new limits to the Service.
							</li>
							<li>
								You can stop using the Service at any time. You may cancel and delete your account at any time here.
								However, you continuing to use the app constitutes your consent to us collecting data, mentioned within
								the terms, and processing the same.
							</li>
							<li>
								You can withdraw consent to the use and/or processing of your personal data by contacting us at
								barun@neuu.in and we shall remove the same shortly.
							</li>
							<li>
								We may temporarily or permanently suspend or terminate your account or impose limits on or restrict your
								access to parts or all of the Service at any time, without notice and for any reason, including, but not
								limited to, violation of these Terms, court order, or inactivity.
							</li>
							<li>
								We may amend these Terms at any time by informing you of the amended terms via email to your email
								address. Such amendments will be effective when we email a notice of the amendments to you.
								Alternatively, or additionally, we may display amended terms to you when you access Vending Buddy, in which case
								such terms shall be effective when they are posted on the website/mobile application.
							</li>
						</ol>
					</li>
					<li>
						Force Majeure -
						<ol className='lower-alpha'>
							<li>
								Without prejudice to any other provision herein, the Proprietor shall not be liable for any loss, damage or
								penalty as a result of any delay in or failure to deliver or otherwise perform hereunder due to any
								cause beyond Proprietor’s control, including, without limitation, acts of the User or other Users, embargo
								or other governmental act, regulation or request affecting the conduct of the Proprietor’s business, fire,
								explosion, accident, theft, vandalism, riot, acts of war, epidemics, pandemics, strikes or other labour
								difficulties, lightning, flood, windstorm or other acts of God.
							</li>
						</ol>
					</li>
					<li>
						Warranties and Disclaimers -
						<ol className='lower-alpha'>
							<li>
								TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, Vending Buddy, ITS PARENT COMPANIES, SUBSIDIARIES, AFFILIATES,
								OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, PARTNERS, LICENSORS AND DISTRIBUTORS (COLLECTIVELY
								“Vending Buddy ENTITIES”) DO NOT MAKE ANY REPRESENTATIONS, PROMISES, OR WARRANTIES, EXPRESS OR IMPLIED, ABOUT THE
								SERVICE. WE PROVIDE OUR SERVICE “AS-IS,” “WITH ALL FAULTS,” AND “AS AVAILABLE.” YOUR USE OF THE SERVICE
								IS AT YOUR OWN RISK AND WE DO NOT REPRESENT, PROMISE, OR WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED,
								TIMELY, SECURE, OR ERROR-FREE. YOU UNDERSTAND AND AGREE THAT NO DATA TRANSMISSION OVER THE INTERNET OR
								INFORMATION STORAGE TECHNOLOGY CAN BE GUARANTEED TO BE SECURE, AND Vending Buddy EXPRESSLY DISCLAIMS ANY
								WARRANTIES, EXPRESS OR IMPLIED, TO THAT EFFECT. WE MAKE NO COMMITMENTS, PROMISES OR WARRANTIES ABOUT THE
								SERVICE OR THE SUPPORT WE PROVIDE FOR THE SERVICE OR THE SERVICE’S RELIABILITY, QUALITY, ACCURACY,
								AVAILABILITY, OR ABILITY TO MEET YOUR NEEDS, PROVIDE CERTAIN OUTPUTS OR ACHIEVE CERTAIN RESULTS.
							</li>
							<li>
								SOME JURISDICTIONS PROVIDE FOR CERTAIN IMPLIED WARRANTIES, SUCH AS THE IMPLIED WARRANTY OF
								MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. TO THE FULLEST EXTENT PERMITTED
								BY APPLICABLE LAW, WE DISCLAIM ANY AND ALL IMPLIED OR EXPRESS PROMISES OR WARRANTIES ABOUT THE SERVICES.
							</li>
						</ol>
					</li>
					<li>
					LIMITATION OF LIABILITY -
						<ol className="lower-alpha">
							<li>
								TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE AND UNDERSTAND THAT Vending Buddy ENTITIES WILL NOT
								BE LIABLE FOR: ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, TREBLE OR OTHER MULTIPLES OF DAMAGES,
								EXEMPLARY OR PUNITIVE DAMAGES ARISING FROM OR IN CONNECTION WITH THESE TERMS OR YOUR USE OF THE SERVICE.
								Vending Buddy ENTITIES ARE NOT RESPONSIBLE FOR ANY LOST PROFITS, LOST REVENUES, LOST BUSINESS OPPORTUNITIES,
								DIMINUTION IN VALUE, INCLUDING ANY ALLEGED LOSS OR DIMINUTION IN VALUE OF PERSONAL INFORMATION, OR ANY
								OTHER LOSSES (COLLECTIVELY, “LOSSES”) ARISING FROM OR IN CONNECTION WITH THESE TERMS OR YOUR USE OF OR
								ACCESS TO THE SERVICE, INCLUDING, BUT NOT LIMITED TO, LOSSES RESULTING FROM OR IN CONNECTION WITH: THE
								DELETION OF, ALTERATION OF, MIS-DELIVERY OF, OR FAILURE TO STORE DATA MAINTAINED OR TRANSMITTED BY THE
								SERVICES; THE LIMITING, SUSPENSION OR TERMINATION OF YOUR ACCOUNT; YOUR DOWNLOADING OR SHARING OF
								INFORMATION, INCLUDING PERSONAL INFORMATION, VIA THE SERVICES; THE UNAUTHORIZED ACCESS TO YOUR ACCOUNT
								OR ANY DATA MAINTAINED OR TRANSMITTED BY THE SERVICES; Vending Buddy ENTITIES WILL NOT BE LIABLE FOR PROBLEMS
								CAUSED BY OTHERS, THE WRONGFUL OR UNLAWFUL ACTIONS OF THIRD PARTIES, OR AN ACT OF GOD. THE LIMITATIONS
								AND EXCLUSIONS IN THESE TERMS WILL APPLY WHETHER OR NOT Vending Buddy HAS BEEN ADVISED OF OR SHOULD HAVE BEEN
								AWARE OF THE POSSIBILITY OF ANY LOSSES ARISING.
							</li>
							<li>
								TO THE FULLEST EXTENT PERMITTED BY LAW, Vending Buddy ENTITIES ARE NOT LIABLE IN CONNECTION WITH ANY DISPUTES
								THAT ARISE OUT OF OR RELATE TO THESE TERMS OR SERVICES FOR ANY AMOUNT GREATER THAN THE AMOUNT YOU PAID
								TO US FOR THE SERVICES
							</li>
						</ol>
					</li>
					<li>
						Privacy Policy –
						<div style={{ paddingLeft: 10, paddingBottom: 10 }}>
							The information we learn from customers helps us personalise and continually improve your shopping
							experience at Vending Buddy. We also use this information to improve our platform, prevent or detect fraud or
							abuses of our website and enable you to have a grand experience. We use Cookies and Device Data that allow
							us to connect your activity within Vending Buddy. We collect information to provide better services to all our
							users – from figuring out basic stuff such as which language you speak, to more complex things like which
							services you find helpful. The information we collect, and how that information is used, depends on how
							frequently you use our services and how you manage your privacy controls internally within your device. We
							will ask for your explicit consent to share any sensitive personal information. Additionally, we will also
							ask for your consent before using your information for a purpose that isn’t covered in this Privacy
							Policy.
						</div>
						<ol className='lower-alpha'>
							<li>
								User Information: We collect mobile number for the User to login to access the Service. The User
								acknowledges that this is reasonable to complete user authentication for Vending Buddy and accordingly consent to
								our collection of such information.
							</li>
							<li>
								[upon your access, the website/application may also collect certain information automatically,
								including, but not limited to, the type of mobile device you use, your mobile devices unique device ID,
								circle of the IP address of your mobile device, your mobile operating system, the type of mobile
								Internet browsers you use, and information about the way you use the Service.
							</li>
							<li>
								We may use the information you provided us to contact you from time to time to provide you with
								important information, required notices and marketing promotions and also improve your activities while
								accessing Vending Buddy.
							</li>
							<li>
								We may also use your personal information to improve our services and user experience on the
								website/mobile application, to enforce our legal rights as permitted under law, and otherwise with your
								consent.
							</li>
							<li>
								We may request access or permission to and track location-based information from your mobile device
								while you are accessing the website/mobile application, to provide location-based services. We may also
								collect the precise location of your device when the app is running in the foreground, background, or
								even if you are not directly using the application depending on your device and its settings. Your
								device, as well as the Vending Buddy mobile application, provides you with options to control how and when we
								collect your geolocation. This is only to better the User’s experience on the Vending Buddy. You may be able to
								disallow our use of certain location data through your device or browser settings, for example, by
								disabling “Location” services for the Vending Buddy application in your device privacy settings. By allowing Vending Buddy
								access to the same the User acknowledges and accepts that Vending Buddy shall be aware of the User’s Geo-Location
								at any time. If you wish to change our access or permissions, you may do so in your device’s settings.
							</li>
							<li>
								The User upon moving to payment page shall be taken to a payment gateway in which the User may link his
								mobile wallets or cards to make the payment to Vending Buddy. The User acknowledges that though Vending Buddy is assisting
								in the User’s experience by having a payment gateway, We do not have access to any financial information
								that the User enters after accessing the payment gateway. Additionally the User acknowledges and accepts
								that upon entering the payment gateway the actions of the User would be governed by the Terms of Use of
								the entity managing such payment gateway.
							</li>
							<li>
								We maintain physical, electronic and procedural safeguards in connection with the collection, storage
								and disclosure of all personal information.
							</li>
							<li>
								We will share your information with third parties only in the ways that are described in this privacy
								policy. We may disclose the information that we collect (including automatically collected information)
								unless consent to the same has been specifically withdrawn by the User. We will not share your contact
								information at any point without your prior content but You, as a User, have the ability, to remove your
								information from the system and to restrict our access and use of your personal data;
							</li>
							<li>
								We shall provide all information that is to be provided when required by law, such as to comply with a
								summons, or similar legal process as well as when we believe in good faith that disclosure is necessary
								to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a
								government request;
							</li>
							<li>
								If in the event that Barun Kumar Ghadia is involved in a merger, acquisition, or sale of all or
								a portion of its assets, you will be notified via email and/or a prominent notice on our Web site of any
								change in ownership or uses of this information, as well as any choices you may have regarding this
								information.
							</li>
							<li>
								We also may share data that is not linkable to a particular consumer or device (for example, information
								that has been aggregated with other records) for general business purposes.
							</li>
							<li>
								Tracking Technologies: We may use cookies, web beacons, tracking pixels, and other tracking technologies
								on the Application to help customize the Application and improve your experience. When you access the
								Application, your personal information is not collected using tracking technology. Most browsers are set
								to accept cookies by default. You can remove or reject cookies but be aware that such action could
								affect the availability and functionality of the Application.
							</li>
							<li>
								The website/mobile application may contain links to third-party websites and applications of interest,
								including advertisements and external services, that are not affiliated with us. Once you have used
								these links to leave Vending Buddy, any information you provide to these third parties is not covered by this
								Privacy Policy, and we cannot guarantee the safety and privacy of your information. Before visiting and
								providing any information to any third-party websites, you should inform yourself of the privacy
								policies and practices (if any) of the third party responsible for that website, and should take those
								steps necessary to, in your discretion, protect the privacy of your information. We are not responsible
								for the content or privacy and security practices and policies of any third parties, including other
								sites, services or applications that you may access in such case.
							</li>
							<li>
								Release of User Information: We release account and other personal information when we believe release
								is appropriate to comply with applicable law; enforce or apply our Conditions of Use and other
								agreements; or protect the rights, property or safety of merchants, our users or others. This includes
								exchanging information with other companies, organisations, government or regulatory authorities for
								fraud protection and credit risk reduction. Obviously, however, this does not include selling, renting,
								sharing or otherwise disclosing personally identifiable information from customers for commercial
								purposes in a way that is contrary to the commitments made in this Privacy Policy.
							</li>
							<li>
								The User can choose to stop all collection of information by us easily by uninstalling through standard
								uninstall processes as may be available as part of your mobile device or via the mobile application
								marketplace or network. You can also request to opt-out via email, at [•].
							</li>
							<li>
								By using or continuing to use Vending Buddy, you agree to our use of your information (including your personal
								information and/or your sensitive personal data or information) in accordance with this Privacy Policy,
								as may be amended from time to time by Vending Buddy in its discretion. You also agree and consent to us
								collecting, storing, processing, transferring and sharing information (including sensitive personal data
								or information) related to you with third parties or service providers for the purposes as set out in
								this Privacy Policy.
							</li>
							<li>
								You may contact us at [•] if you wish to obtain: (a) confirmation on whether your respective Personal
								Data has been processed or is being processed; (b) brief summary of your respective personal information
								that has been processed or is being processed; and (c) brief summary of the Terms. You may also contact
								us if you wish any respective information to be corrected or removed or deleted.
							</li>
						</ol>
					</li>
					<li>
						Data Retention Policy
						<ol className='lower-alpha'>
							<li>
								We will retain collected information for as long as you access the website/mobile application and for a
								reasonable time thereafter.
							</li>
							<li>
								We may retain the information that is collected automatically for up to 24 months and thereafter may
								store it in aggregate.
							</li>
							<li>
								If you would like us to delete collected information that you have provided, please contact us at
								barun@neuu.in and we will respond in a reasonable time.
							</li>
							<li>
								The User must note that some or all the collected data may be required in order for a proper experience.
							</li>
						</ol>
					</li>
					<li>
						Feedback -
						<ol className='lower-alpha'>
							<li>
								You agree that any recommendation, idea, proposal, suggestion, feedback or other input <b>(“Feedback”)</b> you
								submit to Vending Buddy related to its service, websites, apps, or technology may be used by Vending Buddy without any
								notice, obligation, restriction, reimbursement or compensation to you and you waive (or agree not to
								enforce) any and all rights that may now or in future exist (including moral and equivalent rights) in
								any Feedback.
							</li>
						</ol>
					</li>
					<li>
						About these Terms -
						<ol className='lower-alpha'>
							<li>
								Modification of the Terms. We may modify the Terms from time to time to keep in compliance with current
								law as well any future legislations that aim to protect information and privacy. Unless we indicate
								otherwise, modifications will be effective as of the date they are posted on this page or any successor
								page. You should look at the Terms regularly. We will provide notice of material modifications.
							</li>
							<li>
								Continued Use of the Service. You may stop using the Service at any time, but your continued use of or
								subscription to the Service after the effective date of any modifications to the Terms means that you
								agree to the Terms as modified as well as consent to Vending Buddy’s collection and processing of User data.
							</li>
							<li>
								Waiver and Severability of Terms. The failure of the Proprietor to exercise or enforce any right or
								provision of these Terms will not constitute a waiver of such right or provision. If any provision (or
								part of a provision) of these Terms is found to be invalid, the Proprietor and you nevertheless agree to
								give effect to the intentions as reflected in the provision, and the other provisions of these Terms
								remain in full force and effect.
							</li>
							<li>
								Assignment by Proprietor. The Proprietor may freely assign these Terms and all of the policies and other
								documents incorporated or referenced in it (including all rights, licenses, and obligations under it or
								them), in whole or in part and without notice, for any reason, including for the purpose of internal
								restructuring (for example, mergers or liquidations).
							</li>
						</ol>
					</li>
					<li>
						Grievance Redressal and Dispute Resolution -
						<ol className='lower-alpha'>
							<li>
								The Proprietor shall take every effort to give Users a comfortable and personal experience on the platform.
								Despite this if you as a User have any complaint with respect to (a) information privacy or (b) any
								other reasonable grievance – You may communicate the same with us by contacting us at barun@neuu.in {' '}
							</li>
							<li>
								If you believe that Vending Buddy has not adhered to this Privacy Policy you may write to our Grievance Redressal
								Officer in the address and details given below. In your email, please describe in as much detail as
								possible ways in which you believe the Privacy Policy has not been complied with. We will investigate
								your complaint within reasonable period of time.
								<br />
								Grievance Redressal Officer: Mr. Barun Kumar Ghadia <br />
								Office Address:  <br />
								Survey no.56/13, Hosur Rd, near Sai Baba Temple, <br />
								Garvebhavi Palya, Bengaluru, Karnataka 560068 <br />
								Email ID: barun@neuu.in
							</li>
							<li>
								We will do our best to resolve any disputes about these Terms of Use. If you wish to bring a legal claim
								against us, these Terms, as well as all user activity on Vending Buddy shall be governed by and construed in
								accordance with the laws of India.
							</li>
							<li>
								You agree that all claims, differences or disputes arising under or in connection with or in relation
								hereto Vending Buddy, the Terms, relating to or in connection with these Terms, or transactions entered into on
								Vending Buddy, or the relationship between User and Vending Buddy shall be subject to the exclusive jurisdiction of the
								courts at Delhi and the User hereby accedes to and accepts the jurisdiction of such courts.
							</li>
						</ol>
					</li>
				</ol>
				<p style={{fontSize: '20px'}}>
					<MailOutlineIcon fontSize={'small'}></MailOutlineIcon> Email Contact: barun@neuu.in
				</p>
				<p style={{fontSize: '20px'}}>
					<PhoneIcon fontSize={'small'}></PhoneIcon> Customer Care Number : 8951359305
				</p>

			</main>
			<p className={classes.p}>
				<center>
					<a href={'/'}>Home</a> | <a href={'/aboutus'}>About Us</a> | <a href={'/contactus'}>Contact Us</a> | <a href={'/terms-and-conditions'}>Terms</a> | <a href={'/shipping'}>Shipping</a>
				</center>
			</p>
		</section>
	);
};

export default Terms;
